import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import axiosInstance from "../../utils/axiosInstance";
import { handleDowloadFile } from "../../utils/fileHelper";

interface ExportState {
  isLoading: boolean;
  exportType: string;
  error: string | null;
}

const initialState: ExportState = {
  isLoading: false,
  exportType: "",
  error: null,
};

export const exportFile = createAsyncThunk(
  "export/exportFile",
  async (
    {
      path,
      name,
      exportType,
      paramsValue,
      filter,
      userData,
    }: {
      path: string;
      name: string;
      exportType: string;
      paramsValue?: {
        key?: string;
        value?: string;
      };
      filter?: any;
      userData?: any;
    },
    { rejectWithValue },
  ) => {
    try {
      const requestBody = {
        [paramsValue?.key]: paramsValue?.value,
        show_zero_holding: filter?.showNonZero ?? false,
        filter: JSON.stringify(filter?.customFilter) ?? {},
      };

      const response = await axiosInstance.get(`${path}${exportType}/`, {
        params: requestBody,
      });

      handleDowloadFile({
        fileData: response.data,
        applicaionType:
          exportType === "export_csv" ? "text/csv" : "application/pdf",
        fileName: `${userData?.name}_${name}`,
        extensionType: exportType === "export_csv" ? "csv" : "pdf",
      });

      toast.success("Your file is successfully downloaded.");
      return exportType;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, please try again.",
      );
      return rejectWithValue(
        error?.response?.data?.message ||
          "Something went wrong, please try again.",
      );
    }
  },
);

const exportSlice = createSlice({
  name: "export",
  initialState,
  reducers: {
    resetExportState: (state) => {
      state.isLoading = false;
      state.exportType = "";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(exportFile.pending, (state, action) => {
        state.isLoading = true;
        state.exportType = action.meta.arg.exportType;
        state.error = null;
      })
      .addCase(exportFile.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(exportFile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetExportState } = exportSlice.actions;
export default exportSlice.reducer;
